import { createFilterOptions } from "@material-ui/lab/useAutocomplete";

import { Location } from "shared/types";

export const filterLocationOptions = (matchFrom: "any" | "start" = "any") =>
	createFilterOptions({
		matchFrom,
		stringify: (option: Location | any) => option.description
	});
